import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { EventTemplate } from '../../../types/EventTemplate';
import { mutationKeys } from '../mutationKeys';

export const updateEventTemplate = async (uuid: string | undefined, formData: EventTemplate) => {
  if (!uuid) return null;
  const response = await CustomAxios.put(`event_templates/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateEventTemplateFormProps {
  uuid?: string;
  onSuccessCallback: () => void;
}
export function useUpdateEventTemplate({ uuid, onSuccessCallback }: UseUpdateEventTemplateFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEventTemplate],
    mutationFn: (formData: EventTemplate) => updateEventTemplate(uuid, formData),
    onSuccess: (data: EventTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEventTemplates, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const EventTemplate: EventTemplate = err.response.data as EventTemplate;
        queryClient.setQueryData([queryKeys.allEventTemplates, EventTemplate.uuid], EventTemplate);
      }
    },
  });
}
